export const pdfFontSize = 16